export default __webpack_public_path__ + "static/media/3.5f5515e1.png";